/**
 * Food and treasure (spec 02 §7.2, §7.3): what a popped monster leaves and what a level offers.
 * Each of the 47 foods (`FOODS`, geon's editor names) has its own model, after the C64's item
 * graphics in the arcade's colours: about 1.4 tiles across once the game scales it by 1.35 (the
 * C64's items are 2x2 characters), built on its base so it sits on a platform, facing +z. The
 * builders live in `./foods/`, one file per kind; their colours are `content/palettes/foods.json`.
 * The giant bonus items (02 §7.6) reuse these at 2.6x, plus the blue box's blue diamond.
 */

import { MeshBuilder } from '../kit/MeshBuilder';
import type { Palette } from '../palette';
import { FRUIT } from './foods/fruit';
import type { Builder } from './foods/kit';
import { MEALS } from './foods/meals';
import { SWEETS } from './foods/sweets';
import { fallbackGem, TREASURE } from './foods/treasure';
import { VEG } from './foods/veg';

const BUILDERS: Record<string, Builder> = { ...FRUIT, ...VEG, ...SWEETS, ...MEALS, ...TREASURE };

/** geon's short name for the ramen bowl, and the editor's own spelling of persimmon. */
const ALIASES: Record<string, string> = { 'ramen bowl': 'ramen', persimon: 'persimmon' };

const FALLBACK = ['gemPurple', 'gemRed', 'gemGreen', 'diamondBlue', 'diamondYellow'] as const;

/** The model of the item called `name` (the sim's food-table name), or a gem for a name with no model. */
export function foodModel(name: string, p: Palette): MeshBuilder {
  const mb = new MeshBuilder();
  const key = name.toLowerCase();
  const build = BUILDERS[ALIASES[key] ?? key];
  if (build) {
    build(mb, p);
    return mb;
  }
  let h = 0;
  for (const ch of name) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  fallbackGem(mb, p, FALLBACK[h % FALLBACK.length] ?? 'gemRed');
  return mb;
}
